/** */
export const ADD_MANY_ANNOUNCEMENTS_TO_STORE = 'add multiple announcements to store.';
export const ADD_ONE_ANNOUNCEMENT_TO_STORE = 'add one announcement to store.';
export const ADD_ANNOUNCEMENT_SEARCH_RESULTS_TO_STORE = 'add announcement search results to store.';
export const REMOVE_ONE_ANNOUNCEMENT_FROM_STORE = 'remove one announcement from store.';

/** */
export const addManyAnnouncementsToStore = (payload) => ({
  type: ADD_MANY_ANNOUNCEMENTS_TO_STORE,
  payload
});

export const addOneAnnouncementToStore = (payload) => ({
  type: ADD_ONE_ANNOUNCEMENT_TO_STORE,
  payload
});

export const addAnnouncementSearchResultsToStore = (payload) => ({
  type: ADD_ANNOUNCEMENT_SEARCH_RESULTS_TO_STORE,
  payload
});

export const removeOneAnnouncementFromStore = (payload) => ({
  type: REMOVE_ONE_ANNOUNCEMENT_FROM_STORE,
  payload
});
